import { SlidersVertical } from '@sweep-io/sweep-design/dist/icons';
import { SingleSelectFilter } from '../../common/filters/single-select-filter/SingleSelectFilter';
import { ConfigurationType } from '@server/parser';
import { SingleSelectFilterPopoverOption } from '../../common/filters/single-select-filter/SingleSelectFilterPopover';

interface UniversalSearchFiltersProps {
  filterOptions: SingleSelectFilterPopoverOption[];
  selectedFilterValue: string;
  onSelectedFilterItem: (key: ConfigurationType) => void;
  menuOptions: SingleSelectFilterPopoverOption[];
  selectedMenuOption: string;
  onSelectMenuOption: (selectedValue: string) => void;
}

export const UniversalSearchFilters = ({
  filterOptions,
  selectedFilterValue,
  onSelectedFilterItem,
  menuOptions,
  selectedMenuOption,
  onSelectMenuOption,
}: UniversalSearchFiltersProps) => {
  return (
    <SingleSelectFilter
      options={filterOptions}
      selectedItemValue={selectedFilterValue}
      onSelectItem={(key) => onSelectedFilterItem(key as ConfigurationType)}
      icon={<SlidersVertical size="medium" />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      menuOptions={menuOptions}
      selectedMenuOption={selectedMenuOption}
      onSelectMenuOption={onSelectMenuOption}
    />
  );
};
